import React from 'react';
import { styles as doc } from '../../components/documentPage/styles';
import { styles as body } from '../../components/legalDocument/styles';

export const styles: Record<string, React.CSSProperties> = {

  pageTitle: doc.title,
  paragraph: body.paragraph,
  link: body.link,
  status: {
    ...body.effective,
    margin: 0,
  },
};
